import { Trash2 } from "lucide-react";

import { Button } from "../ui";
import type { QueueSettingsForm } from "./useQueueSettingsForm";

type Props = {
  form: QueueSettingsForm;
};

export function DangerSection({ form }: Props) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-surface-200">Delete Queue</p>
          <p className="text-xs text-surface-500">
            This action cannot be undone. All queue data will be lost.
          </p>
        </div>
        <Button
          variant="outline"
          size="md"
          leftIcon={<Trash2 className="size-4" />}
          onClick={() => form.setShowDeleteModal(true)}
          className="!border-error-500/30 !text-error-400 hover:!bg-error-500/10"
        >
          Delete
        </Button>
      </div>
    </div>
  );
}
